import { GlToastMixin } from '../../../../../node_modules/@gitlab/ui/src/index.js?vue3';
import Vue from '../../lib/utils/vue3compat/vue.js?vue3';
import { pageSingleton } from '~/lib/utils/page_singleton';

const getInstance = () =>
  pageSingleton(
    'global_toast',
    () => new Vue({ name: 'GlobalToastRoot', mixins: [GlToastMixin], render: () => null }),
  );

export default function showGlobalToast(...args) {
  return getInstance().$toast.show(...args);
}
